<script>
  import Select from 'svelte-select';
  export let users;
  export let userCategories = [];
  export let form;
  let selectedUserCategoryLabel;
  import { searchKeyByValue } from 'components/Helper.js';
  import { getContext } from 'svelte';
  const showDialog = getContext('showDialog');
  import DropDown from '../../components/DropDown.svelte';

  for (const i in $form.users) {
    $form.users[i].selectLabel =
      $form.users[i].userCategoryName != ''
        ? {
            id: $form.users[i].userCategoryId,
            name: $form.users[i].userCategoryName,
          }
        : undefined;
  }

  const addClientUser = () => {
    let selectUsers = users.filter((item) => item.checked);
    if (selectUsers.length > 0) {
      let arr = $form.users;
      for (let i in selectUsers) {
        let selectUser = selectUsers[i];
        if (searchKeyByValue(arr, 'userId', selectUser.userId) !== -1) {
          return showDialog({ message: 'User already selected' });
        }
      }
      for (let i in selectUsers) {
        let selectedUserLabel = selectUsers[i];
        arr.push({
          ...selectedUserLabel,
          userCategoryName: selectedUserCategoryLabel ? selectedUserCategoryLabel.name : '',
          userCategoryId: selectedUserCategoryLabel ? selectedUserCategoryLabel.id : '',
          selectLabel: undefined,
        });
        $form.users = arr;
      }
      setTimeout(() => {
        users = users.map((item) => {
          item.checked = false;
          return item;
        });
      }, 100);
    } else {
      showDialog({ message: 'Please select user' });
    }
  };
</script>

<div class="p-3 h-100">
  <div class="profile-content mx-auto">
    <div class="block-title mb-4">
      <h3 class="mt-0 title"><span> Staff Assignments </span></h3>
    </div>
  </div>

  <div class="form-group mb-3">
    <div class="row align-items-center mb-3">
      <div class="col-md-3">
        <label
          for=""
          class="form-label mb-0">Staff Assignments</label
        >
      </div>
      <div class="col-md-6 engagement-dropdown">
        <DropDown
          checkbox={true}
          active={true}
          searchbox={true}
          title="Select: Staff Assignments"
          labelFields="name"
          keyFields="id"
          option={users.map((item) => {
            item.name = item.firstName + ' ' + item.lastName;
            return item;
          })}
          checkedFields="checked"
          Style="select-block font-size-13 w-100"
          on:onSelect={(event) => {
            addClientUser();
          }}
        />
      </div>
    </div>
    {#each $form.users as item, i}
      <div class="row align-items-center mb-3 {item.active == 1 ? 'active' : 'inactive'}">
        <div class="col-md-3">
          <div class="client-user-name">
            <span class="text-break">{item.firstName} {item.lastName}</span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="select-block form-group mb-0">
            <Select
              placeholder="Select: Staff Category"
              bind:selectedValue={$form.users[i].selectLabel}
              isMulti={false}
              items={userCategories}
              showChevron={true}
              isClearable={true}
              getSelectionLabel={(option) => {
                return option.name;
              }}
              on:select={(ev) => {
                let selectedUserCategoryLabel = ev.detail;
                (($form.users[i].userCategoryName = selectedUserCategoryLabel
                  ? selectedUserCategoryLabel.name
                  : ''),
                  ($form.users[i].userCategoryId = selectedUserCategoryLabel
                    ? selectedUserCategoryLabel.id
                    : ''));
              }}
              on:clear={(ev) => {
                let selectedUserCategoryLabel = undefined;
                (($form.users[i].userCategoryName = selectedUserCategoryLabel
                  ? selectedUserCategoryLabel.name
                  : ''),
                  ($form.users[i].userCategoryId = selectedUserCategoryLabel
                    ? selectedUserCategoryLabel.id
                    : ''));
              }}
              optionIdentifier="id"
              getOptionLabel={(option) => {
                return option.name;
              }}
            />
          </div>
        </div>
        <div class="col-md-5 justify-content-end d-flex">
          <button
            on:click={() => {
              showDialog({
                isDeleteModel: true,
                type: 'confirm',
                title: '',
                message: 'Are you sure ?',
                okFunc: () => {
                  let oldUsers = $form.users;
                  oldUsers.splice(i, 1);
                  $form.users = oldUsers;
                },
              });
            }}
            class="btn btn-link bg-transparent border-0 shadow-none p-0 ms-1"
          >
            <img
              class="icon-16"
              alt=""
              src="/images/remove.svg"
            />
          </button>
        </div>
      </div>
    {/each}
  </div>
</div>

<style lang="scss">
  :global(.user-list-items-block.inactive div.selectContainer) {
    background: #e9ecef;
    border: none;
  }
  :global(.user-list-items-block div.selectContainer) {
    width: 100%;
  }
</style>
